import type React from 'react';
import { forwardRef } from 'react';

import LoadingSpinner from '../../../loading-spinner';
import type { ButtonSize, ButtonVariant } from '../../split-button.types';

type MainButtonProps = {
  children: React.ReactNode;
  disabled: boolean;
  loading?: boolean;
  loadingAriaLabel?: string;
  onClick?: () => void;
  size?: ButtonSize;
  type?: 'button' | 'submit' | 'reset';
  variant?: ButtonVariant;
};

const MainButton = forwardRef<HTMLButtonElement, MainButtonProps>(
  (
    {
      children,
      disabled,
      loading = false,
      loadingAriaLabel = 'Loading',
      onClick,
      size = 'default',
      type = 'button',
      variant = 'secondary',
    },
    ref,
  ) => (
    <button
      /** Do not change/remove these classes */
      className="fp-button fp-split-main fp-custom-appearance text-label-2"
      data-size={size ?? 'compact'}
      data-variant={variant}
      data-loading={loading}
      disabled={disabled}
      onClick={onClick}
      ref={ref}
      tabIndex={0}
      type={type}
    >
      <div className="flex items-center justify-center">
        {loading ? (
          <LoadingSpinner ariaLabel={loadingAriaLabel} color={variant === 'primary' ? 'quinary' : 'primary'} />
        ) : (
          <span className="inline-block overflow-hidden text-ellipsis whitespace-nowrap">{children}</span>
        )}
      </div>
    </button>
  ),
);

export default MainButton;
